import {mapActions, mapGetters} from "vuex";
import {} from "vuex";
import NeoNewsExpanded from "@/components/news-expanded";
import AdverseMediaExpand from "@/components/adverse-media-expand";
import NeoCorporateRecordsMore from "@/components/corporate-records-more";
import {EventBus} from "@/main.js";

export default {
    name: "monitoring-differential-highlighter",
    components: {
        NeoNewsExpanded,
        AdverseMediaExpand,
        NeoCorporateRecordsMore,
    },
    props: {
        cardComponent: {
            type: String,
            default: "",
        },
        data: {
            type: Array,
            default: [],
        },
        meta_data: {
            type: Object,
            default: null,
        },
        differentials: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {};
    },
    computed: {
        ...mapGetters([]),
        isMonitoringTab() {
            return this.$route.name == "monitoring";
        },
    },
};
